// Migration only runs for GradeXpert Production, the API takes the app name in the URL
export const migrationApplication = "GradeXpert";

const basePath = "/gradexpert/production/migration";

export const migrationListPath = `${basePath}/list`;
export const migrationCreatePath = `${basePath}/create`;
export const migrationDetailPath = (migrationId: string) => `${basePath}/detail?migrationId=${migrationId}`;
